import script from "./summary.vue?vue&type=script&setup=true&lang=ts"
export * from "./summary.vue?vue&type=script&setup=true&lang=ts"

import "./summary.vue?vue&type=style&index=0&id=f4ac7466&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4ac7466"]])

export default __exports__